'use client'

import { Accordion, AccordionDetails, AccordionSummary, styled } from '@mui/material'

export const ProductDetailsAccordionMain = styled(Accordion)({
  boxShadow: 'none',
  borderTop: 'none',
  '&::before': {
    backgroundColor: 'transparent',
  },
})

export const ProductDetailsAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  paddingLeft: 0,
  margin: 0,

  borderBottom: `3px solid ${theme.palette.border.default}`,
}))

export const ProductDetailsAccordionDetails = styled(AccordionDetails)({
  paddingLeft: 0,
  paddingRight: 0,
})
